<template>
    <div>
        <div v-if="requisitionsOnTaskList">
            <modal v-if="showModal" :type="modalType" :data="modalData" @close="closeModal" />

            <p v-if="requisitionsOnTaskList.length === 0 && getActiveTaskId !== ''"><em>Der er ikke nogen entreprenøropgaver.</em></p>

            <div class="grid-x accordion-header" style="margin-bottom: 9px; margin-top: 9px; margin-left: 0px; justify-content: end;">
                <div v-if="requisitionsOnTaskList && requisitionsOnTaskList.length > 0" @click="closedRequisitions = !closedRequisitions" class="filter-supply closed checkbox-right checkbox-text">
                    <div :class="{'active': closedRequisitions}" class="flexbox-center task">
                        <icon v-if="closedRequisitions" class="small-svg fill-white" name="checkmark" />
                    </div>
                    <span style="margin-left: 10px;">Vis også godkendte</span>
                </div>
            </div>
            <div class="accordion-item" v-if="requisitionsOnTaskList && requisitionsOnTaskList.length > 0" v-for="(requisition, index) in filteredRequisitionsOnTaskList" :key="requisition.requisitionId">
                <div class="grid-x align-items flexbox-nowrap">
                    <div class="cell auto accordion-container">
                        <transition name="fade">
                            <div class="object-counter" :title="requisition.allObjectsInActivityCount > 0 ? 'Antal objekter tilknyttet' : 'Ingen objekter tilknyttet'" >{{ requisition.allObjectsInActivityCount ? requisition.allObjectsInActivityCount : 0 }}</div>
                        </transition>
                        <div class="grid-x accordion row align-items" @click="select(requisition)" :class="{'selected': requisition.selected}" style="justify-content: space-between;">
                            <div class="cell icon-cell accordion-toggle flexbox-center" @click="requisition.isAccordionOpen = !requisition.isAccordionOpen">
                                <icon class="large-svg fill-dark-gray" :class="{'rotated-accordion': requisition.isAccordionOpen}" name="chevron-right" style="transition: all 0.3s;" />
                            </div>
                            <div class="cell icon-cell item flexbox-center" style="margin: 0px 10px;">
                                <icon class="task-check-svg medium-svg fill-dark-gray" name="task-check" />
                            </div>
                            <div class="cell large-3 item">
                                <span v-if="requisition && requisition.sentToUser">{{requisition.sentToUser}}</span>
                                <span v-if="requisition && requisition.sentToOrganization">{{requisition.sentToOrganization}}</span>
                            </div>
                            <div class="cell large-2 item">
                                <span v-if="requisition && requisition.statusDate">{{ requisition.statusDate | formatDateShort }}</span>
                                <span v-if="requisition && requisition.statusDate">{{ requisition.statusDate | formatTime }}</span>
                            </div>
                            <div class="cell large-2 item">
                                <span v-if="requisition.declined">Afvist</span>
                                <span v-if="requisition.declined">Sendt retur</span>
                            </div>
                            <div class="cell large-2 item flexbox-center activity-status-container">
                                <div class="activity-status" :class="backgroundColor(requisition.status, requisition)">
                                    <template v-if="requisition.declined === true">Accepteret</template>
                                    <template v-else-if="requisition.report.report.approveDate && requisition.report.report.approveDate !== null && requisition.report.report.approveDate !== ''">Godkendt</template>
                                    <template v-else-if="requisition.report.report.readyForApproval === true & requisition.report.report.approveDate === null">Færdigmeldt</template>
                                    <template v-else-if="requisition.status && requisition.status === 'Ny'">Rekvireret</template>
                                    <template v-else-if="!requisition.report.report.approveDate && !requisition.report.report.readyForApproval && requisition.status !== null">{{requisition.status}}</template>
                                    <template v-else-if="!requisition.report.report.approveDate && !requisition.report.report.readyForApproval && requisition.status === null && requisition.report.report.requisitionStatus !== null">{{requisition.report.report.requisitionStatus}}</template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid-x">
                    <div class="cell auto accordion customContentInsertion dropdown-accordion" v-if="requisition.isAccordionOpen" >

                        <div class="grid-x" style="border-bottom: 1px solid #ececec; font-size: 0.85rem; padding-bottom: 10px; padding-top: 6px; margin-bottom: 10px;">
                            <div class="cell auto">
                                Løbenummer: <strong>{{ requisition.serialNumber }}</strong>
                            </div>
                            <div class="cell auto text-right">
                                <router-link :to="{ name: 'requisitionid', params: { id: requisition.requisitionId } }">Gå til entreprenøropgave &raquo;</router-link>
                            </div>
                        </div>

                        <div v-if="taskRequisitionDocumentsSorted(requisition.requisitionId).length > 0" class="grid-x content align-items">
                            <p class="dfiles__description"><icon class="pictures-svg medium-svg fill-dark-gray" name="pictures" style="margin-right: 10px; vertical-align: middle;" />Dokumenter ({{taskRequisitionDocumentsSorted(requisition.requisitionId).length}})</p>

                            <ul class="dfiles-list">
                                <li class="dfiles-item" v-for="file in taskRequisitionDocumentsSorted(requisition.requisitionId)" :key="file.id">
                                    <div class="dfiles-item-image">
                                        <img v-if="file.contentType.startsWith('image')" :src="file.dataSource" width="90" alt="" loading="lazy" />
                                        <icon class="large-svg" v-else :name="getIcon(file)" :class="getIcon(file)" />
                                        <div class="dfiles-item-image-loader"></div>
                                        <button class="dfiles-item-link" v-if="file.contentType.startsWith('image')" @click="documentOpen(file)" :title="file.description ? 'Kommentar: ' + file.description : null"><span class="visually-hidden">Vis billede</span></button>
                                        <button class="dfiles-item-link" v-else @click="documentDownload(file)" :title="file.description ? 'Kommentar: ' + file.description : null"><span class="visually-hidden">Download fil</span></button>
                                        <div class="dfiles-item-description" v-if="file.description" :title="'Kommentar: ' + file.description">
                                            <icon class="small-svg" name="info-2" />
                                        </div>
                                    </div>

                                    <div class="dfiles-item-info">
                                        <div class="dfiles-item-name" v-if="file.contentType.startsWith('image')" :title="$filters.formatDateTime(file.photoTaken)">{{ file.photoTaken | formatDateTime }}</div>
                                        <div class="dfiles-item-name" v-else :title="file.originalFileName">{{ file.originalFileName }}</div>
                                        <div class="dfiles-item-date" v-if="file.dateCreated" :title="`uploadet: ${$filters.formatDateTime(file.dateCreated)}`"><span>Uploadet:</span><br />
                                        <time :datetime="file.dateCreated">{{ file.dateCreated | formatDateTimeShort }}</time></div>
                                        <div class="dfiles-item-buttons">
                                            <button class="dfiles-item-button" title="Tilføj kommentar" v-if="checkDescriptionAvailability(file)" @click="commentFile(file)">
                                                <span class="visually-hidden">Tilføj kommentar</span>
                                                <icon class="small-svg" name="pencil" />
                                            </button>
                                            <button class="dfiles-item-button" title="Download fil" @click="documentDownload(file)">
                                                <span class="visually-hidden">Download fil</span>
                                                <icon class="small-svg" name="download-arrow" />
                                            </button>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="content" v-if="requisition.report.reportObjectSummaries && requisition.report.reportObjectSummaries.length > 0 && showSummaryTable(requisition.report.reportObjectSummaries)">
                            <table v-for="activity in requisition.report.reportObjectSummaries" :key="activity.activityId" style="font-size: 0.85em;">
                                <thead>
                                    <th>{{ activity.activityType }}</th>
                                    <th style="text-align: right">Ikke udført</th>
                                    <th style="text-align: right">Udført</th>
                                    <th style="text-align: right">Samlet</th>
                                </thead>
                                <tbody>
                                    <tr v-if="activity.numberOfPointObjectsNotDone + activity.numberOfPointObjectsDone > 0">
                                        <td>Punkter <em>(antal)</em></td>
                                        <td style="text-align: right">{{ activity.numberOfPointObjectsNotDone }}&nbsp;<span class="unit">stk.</span></td>
                                        <td style="text-align: right">{{ activity.numberOfPointObjectsDone }}&nbsp;<span class="unit">stk.</span></td>
                                        <td style="text-align: right"><u>{{ Number.parseFloat((activity.numberOfPointObjectsNotDone + activity.numberOfPointObjectsDone).toFixed(0)) }}&nbsp;<span class="unit">stk.</span></u></td>
                                    </tr>
                                    <tr v-if="activity.totalLengthNotDone + activity.totalLengthDone > 0">
                                        <td>Linjer <em>(længde)</em></td>
                                        <td style="text-align: right">{{ activity.totalLengthNotDone }}&nbsp;<span class="unit">m</span></td>
                                        <td style="text-align: right">{{ activity.totalLengthDone }}&nbsp;<span class="unit">m</span></td>
                                        <td style="text-align: right"><u>{{ Number.parseFloat((activity.totalLengthNotDone + activity.totalLengthDone).toFixed(2)) }}&nbsp;<span class="unit">m</span></u></td>
                                    </tr>
                                    <tr v-if="activity.totalAreaNotDone + activity.totalAreaDone > 0">
                                        <td>Flader <em>(areal)</em></td>
                                        <td style="text-align: right">{{ activity.totalAreaNotDone }}&nbsp;<span class="unit">m<sup>2</sup></span></td>
                                        <td style="text-align: right">{{ activity.totalAreaDone }}&nbsp;<span class="unit">m<sup>2</sup></span></td>
                                        <td style="text-align: right"><u>{{ Number.parseFloat((activity.totalAreaNotDone + activity.totalAreaDone).toFixed(2)) }}&nbsp;<span class="unit">m<sup>2</sup></span></u></td>
                                    </tr>
                                    <tr v-if="activity.numberOfOthersNotDone + activity.numberOfOthersDone > 0">
                                        <td>Øvrige <em>(antal)</em></td>
                                        <td style="text-align: right">{{ activity.numberOfOthersNotDone }}&nbsp;<span class="unit">stk.</span></td>
                                        <td style="text-align: right">{{ activity.numberOfOthersDone }}&nbsp;<span class="unit">stk.</span></td>
                                        <td style="text-align: right"><u>{{ Number.parseFloat((activity.numberOfOthersNotDone + activity.numberOfOthersDone).toFixed(0)) }}&nbsp;<span class="unit">stk.</span></u></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="getRequisitionObjectList(requisition).length === 0">
                            <div class="grid-x content">
                                <span><em>Zoom ind eller flyt på kortet for at vise tilknyttet objekter til denne entreprenøropgave.</em></span>
                            </div>
                        </div>
                        <div class="grid-x content dropdown-accordion">
                            <div class="object-item" v-for="reportObj in getRequisitionObjectList(requisition)" :key="reportObj.requisitionId">
                                <div class="grid-x object-row" :class="{'object-clickable': reportObj.geomWkt}" @click="highlightObject(reportObj)">
                                    <div class="cell icon-cell flexbox-center" style="width: 30px; justify-content: left;">
                                        <icon v-if="reportObj.geomWkt" class="small-svg fill-dark-gray" name="location" />
                                        <icon v-else class="small-svg fill-dark-gray" name="asset" />
                                    </div>
                                    <div class="cell auto">
                                        <span class="object-name" v-if="reportObj && !reportObj.name && !reportObj.LayerName && !reportObj.layerName">Intet navn eller id på objekt</span>
                                        <span class="object-name" v-if="reportObj && reportObj.LayerName">{{reportObj.LayerName}}</span>
                                        <span class="object-name" v-if="reportObj && reportObj.layerName && !reportObj.LayerName">{{reportObj.layerName}}</span>
                                        <span class="object-name" v-if="(reportObj && reportObj.LayerName && reportObj.name) || reportObj && reportObj.layerName && reportObj.name"> - </span>
                                        <span class="object-name" v-if="reportObj && reportObj.name">{{reportObj.name}}</span>
                                        <span class="object-description" v-if="reportObj && reportObj.objectDescription && reportObj.objectDescription !== '[]'" v-html="formatDescription(reportObj)">({{formatDescription(reportObj)}})</span>
                                        <div v-if="reportObj.reportNote" class="large-5 cell">
                                            <span>{{reportObj.reportNote}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="activity" class="grid-x entrepreneur-work list-row activity" style="margin-right: 0px;" v-for="(activity, aIndex) in reportObj.activityList" :key="aIndex" @click="openModal('task-modal-requisition', activity)">
                                    <div class="cell large-1">
                                        <icon v-if="activity.createdByContactor" class="task-check medium-svg fill-primary" name="user-reverse-helmet" />
                                        <icon v-else class="task-check medium-svg fill-primary" name="task-check" />
                                    </div>
                                    <div class="cell auto item truncate-fade truncate-fade-entrepreneur">
                                        <span>{{activity.activityType}}</span>
                                        <span>{{activity.description}}</span>
                                    </div>
                                    <div class="cell large-3 item truncate-fade truncate-fade-entrepreneur">
                                        <icon class="small-svg fill-primary" v-if="activity.reportNote" name="bubble" />
                                        <span v-if="activity.reportNote">{{ activity.reportNote }}</span>
                                    </div>
                                    <div v-if="activity.latestDate" class="cell large-3 flexbox-center">
                                        <icon class="small-svg fill-dark-gray" name="flag" />
                                        <span v-if="activity.latestDate">&nbsp; {{checkDate(activity.latestDate)}} <span v-if="checkDate(activity.latestDate) !== 'Tidsplan overskredet!'">dag<span v-if="checkDate(activity.latestDate) > 1">e</span> tilbage</span></span>
                                    </div>
                                    <div v-if="activity.reportWorkDone !== null" class="cell large-1 flexbox-center">
                                        <icon v-if="activity.reportWorkDone === true" class="medium-svg fill-green" name="checkmark" />
                                        <icon v-if="activity.reportWorkDone === false" class="medium-svg fill-red" name="cross" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import modal from './../../shared/modal/modal.vue'

export default {
    name: 'task-accordion-entrepreneur',
    components: {
        modal
    },
    data () {
        return {
            showModal: false,
            isAccordionSelected: false,
            accordionsOpen: [],
            closedRequisitions: false
        }
    },
    props: {
        onObjectChange: {
            type: Function
        }
    },
    computed: {
        ...mapGetters({
            applicationSettings: 'getApplicationSettings',
            getActiveTaskId: 'getActiveTaskId',
            requisitionsOnTaskList: 'getRequisitionsOnTaskList',
            requisitionsSelected: 'getSelectedRequisitions',
            selectedTask: 'getSelectedTask',
            selectedSupplyType: 'selectedSupplyType',
            taskRequisitionDocuments: 'getTaskRequisitionDocuments'
        }),

        filteredRequisitionsOnTaskList () {
            let list = this.requisitionsOnTaskList
            list.forEach(o => {
                const activity = this.selectedTask.activities.find(a => a.requisitionId === o.requisitionId)
                o.allObjectsInActivityCount = activity ? activity.allObjectsInActivityCount : 0
            })

            if (!this.closedRequisitions) {
                list = list.filter(l => !l.report.report.approveDate)
            }

            list = list.slice(0).sort((a, b) => {
                if (a.requisitionDate < b.requisitionDate) {
                    return 1
                }
                if (a.requisitionDate > b.requisitionDate) {
                    return -1
                }
                return 0
            })

            return list
        }
    },
    methods: {
        ...mapActions({
            // File upload
            documentDescriptionUpdate: 'requisitionDocumentDescriptionUpdate',
            documentOpen: 'taskDocumentOpen',
            documentDownload: 'taskDocumentDownload'
        }),
        openModal (type, data) {
            this.showModal = true
            this.modalType = type
            this.modalData = data
        },
        closeModal () {
            if (this.modalData && this.modalData.updating) {
                this.documentDescriptionUpdate(this.modalData)
            }

            this.showModal = false
        },
        backgroundColor (status, requisition) {
            if (requisition.report.report.approveDate && requisition.report.report.approveDate !== '') {
                return 'purple-status'
            }

            if (status === 'Ny') {
                return 'orange-status'
            }

            if (status === 'Accepteret') {
                return 'blue-status'
            }

            if (status === 'Færdigmeldt') {
                return 'green-status'
            }

            if (status === 'Kaldt tilbage') {
                return 'brown-status'
            }

            if (status === 'Godkendt') {
                return 'purple-status'
            }

            return 'blue-status'
        },
        select (requisition) {
            requisition.selected = !requisition.selected
            this.isAccordionSelected = false
            if (!requisition.selected) {
                const found = this.requisitionsSelected.find(r => r.selected)
                if (found) {
                    this.isAccordionSelected = true
                }
            } else {
                this.isAccordionSelected = true
            }
            this.onObjectChange(this.requisitionsSelected)
        },
        checkDate (latestDate) {
            let date = new Date(latestDate)
            let today = new Date()
            let calc = Math.floor((today - date) / 86400000)
            if (calc < 0) {
                calc = Math.abs(calc)
                return calc
            } else if (calc === 0) {
                return 1
            } else {
                if (!latestDate) {
                    // return 'Ingen tidsfrist'
                    return ''
                } else {
                    return 'Tidsplan overskredet!'
                }
            }
        },
        highlightObject (object) {
            if (object.geomWkt) {
                this.onObjectChange(null, object)
            }
        },
        getRequisitionObjectList (requisition) {
            return requisition.report.objectList
        },
        showSummaryTable (summary) {
            return summary.some((activity) => {
                const points = (activity.numberOfPointObjectsNotDone || 0) + (activity.numberOfPointObjectsDone || 0)
                const lines = (activity.totalLengthNotDone || 0) + (activity.totalLengthDone || 0)
                const areas = (activity.totalAreaNotDone || 0) + (activity.totalAreaDone || 0)
                const others = (activity.numberOfOthersNotDone || 0) + (activity.numberOfOthersDone || 0)

                return (points + lines + areas + others) > 0
            })
        },
        formatDescription (object) {
            if (object.layerName) {
                const mapService = this.applicationSettings.kortinfoSettings[this.selectedSupplyType.code].mapServiceList.find((service) => {
                    return (service.type === 'ogc' || service.type === 'arcgis' || service.type === 'kortinfo' || service.type === 'ogckortinfo') && service.layers.find(layer => layer.name === object.layerName || layer.name === object.LayerName)
                })

                if (mapService && mapService.layers) {
                    const layer = mapService.layers.find(layer => layer.name === object.layerName || layer.name === object.LayerName)

                    if (layer && layer.displayObjectProperties) {
                        const displayObjectProperties = layer.displayObjectProperties
                        let formatted = ''

                        if (displayObjectProperties) {
                            formatted += '('
                        }
                        try {
                            JSON.parse(object.objectDescription).forEach((object, index) => {
                                if (displayObjectProperties && object && object.Name && object.Value) {
                                    if (index > 0 && formatted !== '(') {
                                        formatted += ', '
                                    }
                                    if (displayObjectProperties.find(property => property.name === object.Name) && displayObjectProperties.find(property => property.name === object.Name).displayText) {
                                        formatted += '<span class="object-description__label">' + displayObjectProperties.find(property => property.name === object.Name).displayText + ':</span>'
                                    } else {
                                        formatted += '<span class="object-description__label">' + object.Name + ':</span>'
                                    }
                                    formatted += ' <span class="object-description__value">' + object.Value + '</span>'
                                }
                            })

                            if (object.objectLength) {
                                if (displayObjectProperties) {
                                    formatted += ', '
                                }
                                formatted += '<span class="object-description__label">Længde:</span>'
                                formatted += ' <span class="object-description__value">' + object.objectLength + '</span>'
                            }
                        } catch (error) {
                            console.error('Format object description', error, object.objectDescription)
                            formatted += object.objectDescription
                        }
                        if (displayObjectProperties) {
                            formatted += ')'
                        }

                        return formatted
                    }
                }
            }

            return '<span class="object-description__label">' + object.objectDescription + '</span>'
        },

        taskRequisitionDocumentsSorted (requisitionId) {
            return [...this.taskRequisitionDocuments.filter(document => document.origin.id === requisitionId)].sort((a, b) => {
                let modifier = 1

                if (this.sortDirection === 'DESC') {
                    modifier = -1
                }

                if (a[this.sortKey] < b[this.sortKey]) {
                    return -1 * modifier
                }
                if (a[this.sortKey] > b[this.sortKey]) {
                    return 1 * modifier
                }

                return 0
            })
        },

        getIcon (file) {
            // Determine icon by mime type
            let iconName = 'unknown'

            if (file.contentType.indexOf('pdf') > -1) {
                iconName = 'pdf'
            } else if (file.contentType.indexOf('officedocument') > -1 && file.contentType.indexOf('.document') > -1) {
                iconName = 'doc'
            } else if (file.contentType.indexOf('officedocument') > -1 && file.contentType.indexOf('.presentation') > -1) {
                iconName = 'ppt'
            } else if (file.contentType.indexOf('officedocument') > -1 && file.contentType.indexOf('.sheet') > -1) {
                iconName = 'xls'
            } else if (file.contentType.indexOf('csv') > -1) {
                iconName = 'csv'
            } else if (file.contentType.indexOf('plain') > -1) {
                iconName = 'txt'
            } else if (file.contentType.indexOf('xml') > -1) {
                iconName = 'xml'
            }

            return iconName
        },
        checkDescriptionAvailability (file) {
            if (!file.description && this.hideDescription) {
                return false
            } else {
                return true
            }
        },
        commentFile (file) {
            this.openModal('document-modal-description', file)
        }
    }
}
</script>

<style lang="scss" scoped>
.checkbox-right {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/task/task-accordion-entrepreneur.vue